const content = {
	"consent": {
		"title": "AmbiFi Consent",
		"liabilityRelease": "Liability Release and Express Assumption of Risk",
		"termsPrompt": "Please read carefully BEFORE agreeing to the terms and conditions in using the AmbiFi digital program. Please treat this license and agreement as valuable property.",
		"terms": "AGREEING TO THE TERMS BELOW CONSTITUTES A RELEASE AND WAIVER OF ANY RIGHTS YOU MAY HAVE TO SUE PARTIES ASSOCIATED WITH AMBIFI LLC. THIS RELEASE AND WAIVER MAY BE USED BY AMBIFI LLC IN A COURT OF LAW.  IF YOU DO NOT AGREE TO THE TERMS OF THIS AGREEMENT, YOU MUST IMMEDIATELY REMOVE THIS PROGRAM FROM YOUR DIGITAL DEVICE.  USE OF THIS PROGRAM CONSTITUTES FULL ACCEPTANCE OF THE TERMS AND AGREEMENT BELOW.\n\nAmbiFi is not a direct replacement of the FAA mandated OEM checklist provided with your aircraft. AmbiFi should be a secondary source of information.\n\nRefer to SAFO 17006 for a Safety Alert for Operators. Pilots and operators, other than those operating an aircraft under 14 CFR Part 121 or 135 that choose to use COTS or personally developed checklists should meticulously compare them to the manufacturer’s checklist and placards contained in the POH/AFM to confirm they are consistent. This action will ensure the pilot has all pertinent manufacturer’s information during aircraft flight operations.\n\nAmbiFi gives the user the ability to meet these requirements by customizing all aspects of the content. Be sure to cross-check the content created with the OEM checklists.\n\nBy use of this program, the Purchaser understands, acknowledges, and consents to waiving any rights the purchaser may have to sue any parties associated with this product including, but not limited to AmbiFi, Inc., its heirs, assigns, employees, directors, licensees, invitees, and other Parties which may be contractually associated with this product, and agrees to hold said parties harmless with respect to any existing or future legal action associated with this product.  The Purchaser understands that there is no liability assumed by AmbiFi, Inc., its heirs, assigns, employees, directors, licensees, invitees, and other parties which may be contractually associated with this product except the contractual liability to deliver this product upon receipt of the appropriate consideration.\n\nPurchaser understands that this product is for informational use only and acknowledges that no relationship or duty of any kind exists, or shall be created between AmbiFi, Inc., its heirs, assigns, employees, directors, licensees, invitees, and other parties which maybe contractually associated with this product and any third party, including, but not limited to Purchaser's heirs or assigns.\n\nPurchaser assumes all risk of use associated with this product.\n\nPurchaser further states that he/she is of lawful age and legally competent to consent to the terms herein and does so willingly.\n\nThis product constitutes a partial information source only and is by no means to be viewed as being totally comprehensive or a substitute for the use of other information sources routinely used in flying nor the acquisition of sufficient training and experience.\n\nAmbiFi, Inc. grants to the purchaser the right to use this checklist.  This agreement constitutes permission to exercise the rights granted within and must be retained by you.  This checklist is intended solely for use by the original purchaser.  I understand that the AmbiFi and its digital applications are owned and Copyrighted by AmbiFi, Inc. and is protected by United States copyright laws and international treaty provisions. It may not be copied, rented, leased, loaned, redistributed, or transferred to another party in any way without the expressed written permission of said Released Parties.",
		"agree": "Do you agree to the above consent?",
		"sorry": "Sorry, you must agree to move on. Do you agree?"
	},
	"buttons": {
		"yes": "Yes",
		"no": "No",
		"close": "Close"
	},
	"home": {
		"myActivities": "My Activities",
		"hello": "Welcome to Amba Fy!",
		"helloPrompt": "",
		"welcomeTitle": "Time to become extremely productive.",
		"samplesTitle": "Example Activities",
		"gettingStartedTitle": "Getting Started",
		"recentTitle": "Recent Activities",
		"userGuide": "Download User Guide for more info.",
		"quickStart": "Try the Quick Start activity to give you an overview of the capabilities.",
		"diveIn": "Try a sample if you like to takeoff immediately.",
		"noDownloads": "You have not downloaded any activities yet. Select AmbiFi Cloud to get started.",
		"downloads": "From the menu on the top-left, select an activity to get started.",
		"ambiFiCloud": "AmbiFi Cloud is where you discover, create, edit, and share activities.",
		"productive": "For the most productive editing experience, login to AmbiFi Cloud from your laptop or desktop.",
		"copyright": "© 2020 AmbiFi, Inc. All Rights Reserved.",
		"version": "Version",
		"buttons": {
			"startNew": "Start New",
			"resumeLast": "Resume Last"
		}
	},
	"mira": {
		"speaks": {
			"checklist": "Activity for",
			"list": "List",
			"section": "Section",
			"resetChecklistPrompt": "Are you sure you want to reset the current activity?",
			"resettingList": "Resetting list",
			"resettingSection": "Resetting section",
			"checkAll": {
				"response1": "With great power, comes great responsibility.",
				"response2": "The only time you should cut corners is on a race track.",
				"response3": "I ended up rushing once. I ended up with a tow-bar in my pro-peller.",
				"response4": "A few minutes now could save you a lifetime.",
				"response5": "Is anything really that important to risk everything?",
				"response6": "I give up! You are hopeless!"
			},
			"unableToDictate": "Sorry, I am not able to dictate in the current context.",
			"unableToClearText": "Sorry, I am not able to clear the text of the current item.",
			"goAhead": "Go ahead"
		},
		"responses": {
			"check": "Check",
			"skip": "Skip",
			"removeCheck": "Removing check"
		}
	},
	"menu": {
		"notLoggedIn": "Not logged in",
		"login": "Log In",
		"openCloud": "Open AmbiFi Cloud",
		"home": "Home",
		"toggleSectionsMenu": "Toggle Birdseye View",
		"ambiFiCloud": "AmbiFi Cloud",
		"quickSync": "Quick Sync",
		"resetChecklist": "Reset Current Activity",
		"resetList": "Reset Current List",
		"resetSection": "Reset Current Section",
		"expandAll": "Expand All",
		"collapseAll": "Collapse all",
		"bigCheckOverlay": "Big Check Overlay",
		"checklistsTitle": "Activities",
		"currentSession": "Current Session",
		"session": "Session",
		"prefsTitle": "Preferences",
		"storeCloudHistory": "Store Cloud History",
		"animatedScrolling": "Animated Scrolling",
		"showLabelCheck": "Show Label 'Check'",
		"audioTitle": "Mira",
		"voiceRecognitionTitle": "Talk to Mira",
		"showHistory": "Show Local History",
		"hideHistory": "Hide Local History",
		"focusedMode": "Focused Mode",
		"moveForward": "Always Move Forward",
		"audio": "Audio",
		"tracking": "Tracking",
		"miraSnarky": "Mira is Cynical",
		"readSectionItemDelay": "Read Section Item Delay",
		"voiceSpeed": "Voice Speed",
		"primaryVoice": "Primary Voice",
		"secondaryVoice": "Secondary Voice",
		"challengeResponseMode": "Challenge/Response",
		"useGrammar": "Use Grammar Model",
		"showVoiceCommands": "Show Commands",
		"sayCheck": "Say Check",
		"nightMode": "Night Mode",
		"talkToMiraMessage": "Talk To Mira Info",
		"talkToMira": "Talk to Mira",
		"learnMore": "Learn more",
		"interruptMira": "Interrupt Mira",
		"backgroundNoise": "Background Noise",
		"styles": "Styles",
		"filters": "Filters",
		"itemsFontSize": "Items Font Size",
		"itemsAlign": "Item Alignment",
		"layoutTitle": "Appearance",
		"horizontal": "Horizontal",
		"vertical": "Vertical",
		"simple": "Simple",
		"checkbar": "Checkbar",
		"checkbarSize": "Checkbar Size",
		"checkedColor": "Checked Color",
		"echoCancellation": "Echo Cancellation",
		"columnWidth": "Column Width",
		"maxColumnWidth": "Max Column Width"
	},
	"keywords": {
		"emergency": "Emergency"
	},
	"units": {
		"kias": "KIAS",
		"knots": "Knots",
		"mph": "MPH"
	},
	"alerts": {
		"lang": "Choose a language",
		"goto": "Do you want to proceed?",
		"activityNoContent": "This activity does not have any content. You need at least one Item. It can't be displayed.",
		"congrats": "Congratulations!",
		"congratsMessage": "You have completed the activity.",
		"resetChecklist": "Reset Current Activity",
		"resetChecklistMessage": "Are you sure you want to reset the current activity? This will create a new session.",
		"resetList": "Reset Current List",
		"resetListMessage": "Are you sure you want to reset the current list {list.name}?",
		"resetSection": "Reset Current Section",
		"resetSectionMessage": "Are you sure you want to reset the current section {section.name}?",
		"skippedItems": "You have some skipped items in this section. Do you want to Return, or Move Forward?",
		"micPermissions": "Since this is the first time giving microphone permissions to the app you will need to turn on the Talk to Mira feature one more time.",
		"micPermissionsFailed": "The permission check for the microphone failed. You may have not given permission. You may need to uninstall and re-install the app to give it permission.",
		"voicesAndroid": "With the Google speech engine there are hundreds of voices to choose from. Note: There are different speech engines on a device. Samsung devices typically default to their own, but there is a Google speech engine as well you can typically switch to. In your Settings for the device is where you can switch voice engines as well as download new voices. This can typically be found in the Accessibility settings or Language and Input settings. If you switch engines or download new voices, you will need to unload and reload the app to see the new voices available.",
		"talkToMira": "Talk to Mira enables voice recognition for controlling the activity. It is one input method of many we provide to control the activity. Technologies like Siri, Google Assistant and Alexa take advantage of massive server-side processing on voice and have great processing of background noise. They do good for single questions and answers, but not good when you want to interact in real-time like saying check, check, check rapidly.\n\nFor AmbiFi the requirement for offline speech-to-text and the ability to react rapidly is essential. The technologies for this have come a long way, but they are not yet 100% ideal. For one, background noise can really affect the accuracy. We have add a background noise slider to help with this. Typical values should be in the 2 to 4 range. The higher, the more it tries to reduce background noise. Too high, and even what you say is considered background noise.\n\nAlso, when Mira is speaking she can trip the recognition so by default voice recognition is turned off when she is speaking. You have to wait until she is finished to give a command. We have added a feature Interrupt Mira which will turn this off. Only turn this on when using a headset. When using a headset, since the audio is not being heard by the mic the interruption then can work.\n\nIn our testing the voice recognition works really well when paired with a high-end bluetooth headset and there are still a lot of things we are exploring to improve for the future.",
		"voiceCommands": "\n\nCHECK\nCHECK ITEM\nCHECK IT\nNEXT\nNEXT ITEM\n\nSKIP\nSKIP ITEM\nSKIP IT\n\nLOCATE\nLOCATE ITEM\n\nREAD ITEM\nREAD CURRENT ITEM\n\nREAD SECTION\nREAD CURRENT SECTION\n\nCHECK SECTION\nCHECK CURRENT SECTION\n\nRESET ACTIVITY\nRESET CURRENT ACTIVITY\nRESET LIST\nRESET CURRENT LIST\nRESET SECTION\nRESET CURRENT SECTION\n\nOPEN COMMENTS\nCLOSE COMMENTS\nSHOW COMMENTS\nHIDE COMMENTS\n\nOPEN NOTES\nCLOSE NOTES\nSHOW NOTES\nHIDE NOTES\n\nOPEN LOGBOOK\nCLOSE LOGBOOK\nSHOW LOGBOOK\nHIDE LOGBOOK\n\nOPEN CLOCK\nCLOSE CLOCK\nSHOW CLOCK\nHIDE CLOCK\n\nOPEN NAV OVERLAY\nCLOSE NAV OVERLAY\nSHOW NAV OVERLAY\nHIDE NAV OVERLAY\n\nOPEN BIG CHECK OVERLAY\nCLOSE BIG CHECK OVERLAY\nSHOW BIG CHECK OVERLAY\nHIDE BIG CHECK OVERLAY\n\nEMERGENCY\nEMERGENCY LIST\n\nMIRA {List Name}\nMIRA {Section Name}\n\nMIRA GOTO SKIPPED ITEMS\nMIRA GOTO UNCHECKED ITEMS\n\nMIRA PAUSE\nMIRA PLAY\nMIRA RESUME\nMIRA STOP\n\nMIRA SILENCE\nMIRA SHUT UP\nMIRA BE QUIET\n\nAFFIRMATIVE\nNEGATIVE\n\nGO BACK",
		"acousticModel": "The voice recognition engine supports different acoustic models. You can try different models which may provide better accuracy with your voice.",
		"audioMode": "The operating support supports different audio modes for capturing audio. You can try differet modes.",
		"useGrammar": "There are two types of models the voice recognition engine supports. The default is a Language Model and in testing seems more accurate. You can try using the Grammar Model to see if it gives better results.",
		"listensAggressively": "By default, a rejection filter is applied that rejects some common words. This turns off the rejection filter.",
		"interruptMira": "When Mira is speaking, the voice recognition engine is turned off because Mira hears herself talking and it can trip it up. If using a headset then the mic won't hear what Mira is saying and this can be turned on. This is recommended to be turned ON when using a headset.",
		"backgroundNoise": "This is a background noise filter. Valid values are typically in the 2 to 4 range with 2 removing the least amount of noise.",
        "miraListeningDelay": "Determines how long Mira listens after she is done talking. The Mic turns red when she is listening and goes back to green when she is not listening. When she is not listening you have to speak the wake word (MIRA or HEY MIRA or HELLO MIRA) to have her listen for a command.",
		"showVoiceCommands": "Show all of the voice commands the voice recognition engine is seeing.",
		"echoCancellation": "This removes audio played by the application from the audio captured via the microphone. Changing this requires a restart of the app to take effect.",
		"buttons": {
			"yes": "Yes",
			"no": "No",
			"cancel": "Cancel",
			"submit": "Save + Exit"
		}
	},
	"items": {
		"shared": {
			"ok": "OK ✓"
		},
		"yesNo": {
			"yes": "Yes",
			"no": "No",
			"na": "N/A"
		},
		"image": {
			"showFullscreen": "Show Fullscreen"
		},
		"video": {
			"playFullscreen": "Play Fullscreen"
		}
	}
};

export default content;